import React, { useState } from "react";
import Select from "react-select";
import styled from "styled-components";

const FilterContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  margin: 8px;
  width: 100%;
`;

const StyledSelect = styled(Select)`
  width: 50%;
`;

const StyledNumberInput = styled.input`
  width: 100px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
`;

const Filters = ({ flowTitles, onTitleChange, onDaysChange }) => {
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [days, setDays] = useState(7);

  const handleTitleChange = (selectedOption) => {
    setSelectedTitle(selectedOption);
    onTitleChange(selectedOption ? selectedOption.value : null);
  };

  const handleDaysChange = (event) => {
    const newDays = event.target.value;
    setDays(newDays);
    onDaysChange(newDays);
  };

  const uniqueSortedTitles = Array.from(new Set(flowTitles)).sort();

  const titleOptions = uniqueSortedTitles.map((title) => ({
    value: title,
    label: title,
  }));

  return (
    <FilterContainer>
      <StyledSelect
        value={selectedTitle}
        onChange={handleTitleChange}
        options={titleOptions}
        placeholder="Escolha o Fluxo"
      />
      dias:
      <StyledNumberInput
        type="number"
        value={days}
        onChange={handleDaysChange}
        min="1"
        placeholder="7"
      />
    </FilterContainer>
  );
};

export default Filters;
